/**
 * 窗口大小变化检测函数
 * @param {Function} callback - 窗口大小变化时执行的回调函数
 * @param {number} [delay=200] - 防抖延迟时间(毫秒)
 * @returns {Function} 取消监听的函数
 */
export const onWindowResize = (callback, delay = 200) => {
  // 存储上一次的窗口尺寸
  let lastWidth = window.innerWidth;
  let lastHeight = window.innerHeight;

  // 防抖计时器
  let resizeTimer = null;

  // 实际的处理函数
  const handleResize = () => {
    const currentWidth = window.innerWidth;
    const currentHeight = window.innerHeight;

    // 只有当宽度或高度真正改变时才调用回调
    if (currentWidth !== lastWidth || currentHeight !== lastHeight) {
      const oldWidth = lastWidth;
      const oldHeight = lastHeight;
      callback({
        width: currentWidth,
        height: currentHeight,
        oldWidth,
        oldHeight,
      });

      // 再更新记录
      lastWidth = currentWidth;
      lastHeight = currentHeight;
    }
  };

  // 防抖处理后的函数
  const debouncedHandler = () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResize, delay);
  };

  // 添加事件监听
  window.addEventListener("resize", debouncedHandler);

  // 返回一个取消监听的函数
  return () => {
    window.removeEventListener("resize", debouncedHandler);
    clearTimeout(resizeTimer);
  };
};
